module.exports = __webpack_public_path__ + "static/music-banner-1f6fb1c935ecb4257a4e241c8fa86ea6.jpg";